/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei/core/useGLTF'
import { useFrame } from '@react-three/fiber'

 function Scene({...props}) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/icons.gltf')
  useFrame(()=> {
    group.current.rotation.y += 0.01
  })
  return (
    <group ref={group} {...props} dispose={null}>
      <group position={[props.objectPos.x,props.objectPos.y,props.objectPos.z]} rotation={[0, -0.29, -0.12]} scale={1.8}>
        <mesh geometry={nodes.Sphere.geometry} material={materials['Material.001']} 
        material-color={props.customColors.color2} />
        <mesh geometry={nodes.Sphere_1.geometry} material={materials['Material.007']} 
        material-color={props.customColors.color3}/>
        <mesh geometry={nodes.Sphere_2.geometry} material={materials['Material.022']} 
        material-color={props.customColors.color1}/>
        <mesh geometry={nodes.Sphere_3.geometry} material={materials['Material.006']} 
        />
      </group>
    </group>
    
  )
}

useGLTF.preload('/icons.gltf')


export default Scene;
